<div class="container-fluid spacer-top-navigation">
  <div class="container mb-3">
    <div class="row row--primary">
      <div class="col-12 pl-0 mb-2 d-flex align-items-center">
        <a [routerLink]="savingPlansRoute" class="link-secondary font-default">
          <svg class="icon icon-21"><use xlink:href="/assets/img/svgs/svgset.svg#arrow-left" /></svg>
          {{ 'savings-plan.add-savings-plan.back' | transloco }}
        </a>
      </div>
    </div>
    <div class="row row--primary d-block tile" data-zid="savings-plan-form">
      <div class="col-12 px-0">
        <div class="row mb-4">
          <div class="col-12">
            <h1 class="zero-text p-bigger-bold">
              {{ 'savings-plan.edit-savings-plan.headline' | transloco }}
            </h1>
          </div>
          @if (savingsPlanFacade.selectedAsset$ | async; as asset) {
            @if (asset.instrumentType === InstrumentType.Crypto) {
              <div class="col-12">
                <shared-micar-contracts-nudging class="d-block mt-3" />
              </div>
            }
          }
        </div>
      </div>
      @if (savingsPlanFacade.selectedAsset$ | async; as asset) {
        <div class="col-12 px-0 minh-55">
          <div data-zid="reset-savings-plan-instrument" class="input-group-material asset-search-default mb-2">
            <input class="zero-surface grey-800 cursor-pointer" [value]="asset.name" (click)="resetAsset.emit()" />
            <button class="autocompletion-clear close" type="button" (click)="resetAsset.emit()" data-zid="reset-asset">
              <svg class="icon icon-16 color-secondary">
                <use xlink:href="/assets/img/svgs/svgset.svg#edit" />
              </svg>
            </button>
          </div>
          <div class="d-flex flex-grow color-text-primary font-size-smaller1 mb-5">
            @if (asset.instrumentType !== InstrumentType.Crypto) {
              <span>
                {{ 'savings-plan.savings-plan-form.isin' | transloco }}: {{ asset.isin }}
                {{ 'savings-plan.savings-plan-form.wkn' | transloco }}:
                {{ asset.wkn }}
              </span>
            } @else {
              {{ 'savings-plan.savings-plan-form.shortName' | transloco }}: {{ asset.shortName }}
            }
            <web-components-watchlist-toggle [isin]="asset.isin" />
          </div>
        </div>
        @if (asset.instrumentType === InstrumentType.Crypto && !(customerStateFacade.customerBaseData$ | async)?.hasActiveWallet) {
          <div class="col-12 px-0">
            <div class="mb-5 border-attention">
              <div class="pl-3 pr-3 pt-3 pb-2">
                <div class="font-medium text-size-xlarge">
                  {{ 'trade.create.check-experience-and-ftg.showNoWalletWarning.headline' | transloco }}
                </div>
              </div>
              <div class="pl-3 pr-3 text-size-large">
                <div class="row">
                  <div class="col-12 mb-4">
                    {{ 'trade.create.check-experience-and-ftg.showNoWalletWarning.text' | transloco }}
                    <a class="link-secondary cursor-pointer" (click)="noWalletWarningClick.emit()">{{
                      'trade.create.check-experience-and-ftg.showNoWalletWarning.link' | transloco
                    }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (savingsPlanFacade.savingsPlanToUpdate$ | async; as plan) {
          <div class="col-12 px-0 mt-4">
            <div class="row mb-4">
              <div class="col-12 mb-4">
                <div class="d-flex flex-grow">
                  <div
                    class="input-group-material input-group-material"
                    [class.input-group-material--error]="savingsPlanFacade.existingSavingsPlanError$ | async"
                  >
                    <input
                      data-zid="edit-savings-plan-amount"
                      type="text"
                      autocomplete="off"
                      inputmode="decimal"
                      class="form-control"
                      [value]="plan.amount | ignoreThousandSeparator"
                      (keyup)="changeAmount($event)"
                    />

                    @if (savingsPlanFacade.existingSavingsPlanError$ | async; as error) {
                      <div class="input-group-material-message">
                        {{ error | transloco }}
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            @if (savingsPlanFacade.intervals$ | async; as intervals) {
              @if (savingsPlanFacade.execDates$ | async; as execDates) {
                <div class="row mb-4">
                  <div class="col-12" [class.col-md-6]="intervals.length > 1">
                    <div class="input-group-material select-dropdown" [class.input-group-material--error]="!plan.nextExecDate">
                      <select
                        id="execDatesDropdown"
                        #execDatesDropdown
                        (change)="savingsPlanFacade.changeExecDate(execDatesDropdown.value)"
                      >
                        <option disabled [selected]="!(execDates | includes: plan.nextExecDate)">
                          {{ 'savings-plan.savings-plan-form.nextExecDate-placeholder' | transloco }}
                        </option>
                        @for (execDate of execDates; track $index) {
                          <option [value]="execDate" [selected]="execDate === (savingsPlanFacade.execDate$ | async)">
                            {{ execDate | date: 'shortDate' : 'UTC +2' }}
                          </option>
                        }
                      </select>
                      <label for="nextExecDate">
                        {{ 'savings-plan.savings-plan-form.nextExecDate-label' | transloco }}
                      </label>
                    </div>
                  </div>
                  @if (intervals.length > 1) {
                    <div class="col-12 col-md-6">
                      <div class="input-group-material select-dropdown" [class.input-group-material--error]="!plan.interval">
                        <select
                          data-zid="edit-savings-plan-interval"
                          id="intervalsDropdown"
                          #intervalsDropdown
                          (change)="savingsPlanFacade.changeInterval(intervalsDropdown.value)"
                        >
                          <option disabled>
                            {{ 'savings-plan.savings-plan-form.interval-placeholder' | transloco }}
                          </option>
                          @for (interval of intervals; track $index) {
                            <option [value]="interval" [selected]="interval === plan.interval">
                              {{ 'savings-plan.savings-plan-form.interval.' + interval | transloco }}
                            </option>
                          }
                        </select>
                        <label for="interval">
                          {{ 'savings-plan.savings-plan-form.interval-label' | transloco }}
                        </label>
                      </div>
                    </div>
                  }
                </div>
              }
            }
            <saving-plans-dynamization />
            @if (plan.directDebitForNextExecDateAmount) {
              <div class="row">
                <div class="col-12 mb-2">
                  <span
                    class="hint text-color-grey font-medium text-size-small"
                    [innerHTML]="
                      'savings-plan.savings-plan-form.directDebitForNextExecHint'
                        | transloco: { amount: (plan.directDebitForNextExecDateAmount | currency: 'EUR' : 'symbol' : '1.0-2') }
                    "
                  ></span>
                </div>
              </div>
            }
            @if (asset.instrumentType === InstrumentType.Crypto) {
              <trade-check-experience-and-ftg
                [assetToCheck]="asset"
                (allowedToProceedOrderChange)="acceptRisk($event)"
                [showCancelButton]="false"
              />
            }
          </div>
        }
        <div class="col-12 px-0">
          <web-design-system-button
            data-zid="edit-savings-plan-submit"
            (click)="goNext.emit()"
            [fullwidth]="true"
            [disabled]="(isFormValid$ | async) === false"
          >
            {{ 'savings-plan.savings-plan-form.submit' | transloco | uppercase }}
          </web-design-system-button>
        </div>
        <saving-plans-donau-capital-hint [hasCryptoAsset]="asset.instrumentType === InstrumentType.Crypto" />
      }
    </div>
  </div>
</div>
